import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

// Watches the new game from a play-again invite so the invite can say when the
// game has started or is gone. status: loading | waiting | started | gone.
export default function useReplayRoom(roomId) {
  const [state, setState] = useState({ status: "loading", players: [] });

  useEffect(() => {
    if (!roomId) return undefined;
    setState({ status: "loading", players: [] });
    return onSnapshot(
      doc(db, "rooms", roomId),
      (snap) => {
        if (!snap.exists() || snap.data().isActive === false) {
          setState({ status: "gone", players: [] });
          return;
        }
        const room = snap.data();
        setState({ status: room.gameStatus === "waiting" ? "waiting" : "started", players: room.players || [] });
      },
      () => setState({ status: "gone", players: [] })
    );
  }, [roomId]);

  return state;
}
